import {ADD_APPLICATION_DATA} from "../constants/action-types";

function ApplicationReducer(state = {}, action) {
    switch (action.type) {
        case ADD_APPLICATION_DATA:
            return Object.assign({}, state, {applicationData: action.payload});
        default :
            return state;
    }
}

export default ApplicationReducer